import { render, staticRenderFns } from "./invoice-list.vue?vue&type=template&id=38f9477a&scoped=true"
import script from "./invoice-list.vue?vue&type=script&lang=js"
export * from "./invoice-list.vue?vue&type=script&lang=js"
import style0 from "./invoice-list.vue?vue&type=style&index=0&id=38f9477a&prod&scoped=true&lang=scss"
import style1 from "./invoice-list.vue?vue&type=style&index=1&id=38f9477a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f9477a",
  null
  
)

export default component.exports